export const FirebaseConfig = {
  apiKey: "AIzaSyCDC7xPxPxhQClDQLEFcXt7LAy7wm2hvoQ",
  authDomain: "fir-database-37b02.firebaseapp.com",
  databaseURL: "https://fir-database-37b02.firebaseio.com",
  storageBucket: "fir-database-37b02.appspot.com",
  messagingSenderId: "6926461305"
};



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/environments/FirebaseConfig.ts